// extracted by mini-css-extract-plugin
module.exports = {"container":"_1A0Pvz","footerWidth":"_1hVQay","noPadding":"zaUL6A","isWide":"FfdVan","isFull":"_1Y_hyM","isRelative":"_2Q3wHl","centerText":"_3MSxqD","isNarrow":"_18tPCx"};